import { motion, AnimatePresence } from "framer-motion";
import { ReactNode, useRef } from "react";
import { useLocation } from "react-router-dom";
import { usePrefersReducedMotion } from "@/hooks/usePrefersReducedMotion";

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
}

// App-like spring transition for native feel
const springTransition = {
  type: "spring",
  stiffness: 350,
  damping: 30,
  mass: 0.8,
};

const fadeVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

const slideVariants = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 },
};

const fadeTransition = { duration: 0.15, ease: "easeOut" };

export const PageTransition = ({ children, className }: PageTransitionProps) => {
  const prefersReducedMotion = usePrefersReducedMotion();

  if (prefersReducedMotion) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={slideVariants}
      transition={springTransition}
      className={className}
      style={{ willChange: "transform, opacity" }}
    >
      {children}
    </motion.div>
  );
};

// Lightweight fade for portals/modals
export const FadeTransition = ({ children, className }: PageTransitionProps) => (
  <motion.div
    initial="initial"
    animate="animate"
    exit="exit"
    variants={fadeVariants}
    transition={fadeTransition}
    className={className}
  >
    {children}
  </motion.div>
);

export default PageTransition;
